import { ArrowLeft, ChevronRight, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { LookupAccountOption } from "@/lib/customerLookup";

// The sign-in step for a phone that reaches more than one account. It lists
// the accounts by name and nothing else: whether one has a PIN, an email or
// which phone it holds is only looked up after the buyer picks it.
export function AccountPickerStep({
  options,
  onPick,
  onBack,
  isLoading,
  buttonClassName = "w-full h-14 text-left justify-start text-base font-medium hover:bg-blue-50 hover:border-[#2B5397]",
}: {
  options: LookupAccountOption[];
  onPick: (option: LookupAccountOption) => void;
  onBack: () => void;
  isLoading: boolean;
  buttonClassName?: string;
}) {
  return (
    <div className="space-y-3" data-testid="account-picker">
      <p className="text-sm text-gray-600 text-center">
        This phone number is on more than one account. Which one are you ordering for?
      </p>
      {options.map((option) => (
        <Button
          key={`${option.authType}-${option.accountId}-${option.contactId ?? ""}`}
          type="button"
          variant="outline"
          className={buttonClassName}
          onClick={() => onPick(option)}
          disabled={isLoading}
          data-testid={`button-pick-account-${option.accountId}`}
        >
          {isLoading ? (
            <Loader2 className="h-5 w-5 mr-3 animate-spin" />
          ) : (
            <ChevronRight className="h-5 w-5 mr-3 text-gray-400" />
          )}
          {option.name}
        </Button>
      ))}
      <div className="text-center pt-2">
        <button
          type="button"
          onClick={onBack}
          className="text-sm text-gray-500 hover:underline inline-flex items-center"
          data-testid="link-different-number"
        >
          <ArrowLeft className="h-3 w-3 mr-1" />
          Use a different phone number
        </button>
      </div>
    </div>
  );
}
